export const MAX_FILE_SIZE = 2000000;
